import ItemCaracteristicas from './itemcaracteristicas.vue';
import ItemCaracteristicaForm from './itemcaracteristica-form.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

var routes = [{
        path: '/itemcaracteristicas/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('itemcaracteristicas', ['ADMIN', 'DTYCAL'], ItemCaracteristicas)
    },
    {
        path: '/itemcaracteristicas/new/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('itemcaracteristicas/new', ['ADMIN', 'DTYCAL'], ItemCaracteristicaForm)
    },
    {
        path: '/itemcaracteristicas/edit/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('itemcaracteristicas/edit', ['ADMIN', 'DTYCAL'], ItemCaracteristicaForm)
    },
    {
        path: '/itemcaracteristicas/view/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('itemcaracteristicas/view', ['ADMIN', 'DTYCAL'], ItemCaracteristicaForm, { editable: false })
    },
];
export default routes;
